import React from "react";
import "./contact.css";
// import { useEffect } from "react";

function Contact() {
  // useEffect(() => {
  //     const ifameData = document.getElementById("iframeId")
  //     const lat = 16.83280864634303;
  //     const lon = 74.56555841953461;
  //     ifameData.src = `https://maps.google.com/maps?q=${lat},${lon}&hl=es;&output=embed`
  // })

  return (
    <>
      <h2 className="mt-8 border-b-2 border-[gainsboro] w-[20%] mx-auto items-center flex-col justify-center font-serif text-center text-blue-800 text-[26px] uppercase rounded-2xl">
         Contact Us      
         </h2>
      <div className="grid pt-6 mb-10 xs:grid-cols-1 lg:grid-cols-2">
        <div className="col-span-1 ">
          <div>
            {/* <h1 className=' xs:ml-10 font-bold lg:pl-10 text-blue-800 xs:text-[40px] py-6 text-3xl font-Roboto '>Contact Info</h1> */}
            
            <div className="pl-10 pr-5">
            <h1 className=" xs:mx-auto font-bold  xs:text-[40px] text-blue-900 text-xl font-Roboto ">
                              Address </h1>
              <p className="text-base pt-1 font-Roboto w-[540px] ">
                Nirankari Satsang Bhavan Sangli, Vishnu Anna Fruit Market,
                Dhamani Rd, Sangli, Maharashtra 416416
              </p>
              {/* <iframe id="iframeId2" height="200vh" width="96%" className="pt-1 rounded-xl"></iframe> */}

            </div>
            <div className="grid grid-cols-2 gap-4 pt-5 xs:grid-cols-1 md:mx-10 xs:gap-10 xs:mx-4 ">
              <div className="col-span-1 p-5 border rounded-lg shadow-md">
                <img
                  className="w-10 pb-4 mx-auto"
                  src="image/icon/mi_call.svg"
                  alt="imgicon"
                />
                <h4 className="text-xl font-semibold text-center font-Roboto">
                  Call Us
                </h4>
                <h5 className="text-center text-[16px] py-2 font-Roboto font-medium text-gray-600">
                  +91 1147660200
                </h5>
              </div>
              <div className="col-span-1 p-5 border rounded-lg shadow-md">
                <img
                  className="w-10 pb-4 mx-auto"
                  src="image/icon/guidance_mail.svg"
                ></img>
                <h4 className="text-xl font-semibold text-center font-Roboto">
                  Mail Us
                </h4>
                <h5 className="text-center text-[16px] py-2 font-Roboto font-medium text-gray-600">
                  feedback@nirankari.org
                </h5>
              </div>
            </div>
            
          </div>
        </div>
        <div className="col-span-1 ">
          {/* <h1 className=" xs:mx-auto pb-3 font-bold  xs:text-[40px] text-blue-900 text-xl font-Roboto ">
            Drop us Message
          </h1>
          */}
          <form class="w-full mt-5  max-w-xl">
            <div class="flex  flex-wrap md:-mx-3 mb-6">
              <div class="w-full xs:mb-2 md:w-1/2 px-3 mb-6 md:mb-0">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Your Name
                </label>
                <input
                  class="appearance-none block w-full bg-gray-100 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  type="text"
                  placeholder="Enter Name"
                />
              </div>
              <div class="w-full xs:mb-5 md:w-1/2 px-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Your Email
                </label>
                <input
                  class="appearance-none block w-full bg-gray-100 text-gray-700 border border-gray-100 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  type="email"
                  placeholder="Enter Email"
                />
              </div>
              <div class="w-full xs:mb-2 md:w-1/2 px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-first-name"
                >
                  Contact Number
                </label>
                <input
                  class="appearance-none block w-full bg-gray-100 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  type="number"
                  placeholder="Enter Number"
                />
              </div>
              <div class="w-full xs:mb-5 md:w-1/2 px-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  City
                </label>
                <input
                  class="appearance-none block w-full bg-gray-100 text-gray-700 border border-gray-100 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  type="text"
                  placeholder="City Name"
                />
              </div>
            </div>
            <div class="flex flex-wrap -mt-4 md:-mx-3 ">
              <div class="w-full px-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Massage
                </label>
                <textarea
                  class="appearance-none block w-full bg-gray-100 text-gray-700 border border-gray-100 rounded py-3 px-4 mb-2  focus:outline-none focus:bg-white focus:border-gray-500"
                  type="text"
                  placeholder="Enter Massage"
                />
              </div>              
            </div>
            <button className="flex justify-center mx-auto items-center mt-3 h-10  text-gray-800 rounded-lg text-lg font-bold hover:bg-blue-800 outline-double outline-gray-500  hover:text-white w-[25%]">
              Send
            </button>
          </form>
        </div>
      </div>
      {/* <div className='mt-40 '>
                <iframe id="iframeId" height="500px" width="100%"></iframe>
            </div> */}
    </>
  );
}

export default Contact;
